import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const PermissionRepository = RepositoryFactory.get('PermissionRepository');

import { DefaultStoreActions } from '@/store/utils/requests'
const { get } = DefaultStoreActions(PermissionRepository)

export const STORE_MODULE_NAME = 'permission';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
    },
}
